<template>
  <div class="paymant-page">
		<header-list></header-list>
		
		<div  class="paymant-box">
			<!-- 面包屑导航 -->
			<div class="pb-50 flex flex-y- flex-x-s f-14 c-66">
				<span>当前位置: </span>
				<span class="ml-5">主页</span>
				<span class="iconfont iconxiangyoujiantou mlr-5"></span>
				<span>{{doclibName}}</span>
				<span class="iconfont iconxiangyoujiantou mlr-5"></span>
				<span>{{SYS_TOPIC}}</span>
			</div>
			
			<!-- 支付方式选择 -->
			<div class="paymant-info">
				<!-- 余额以及所需 -->
				<ul class="consume flex-c  f-14 c-66">
					<li class="balance"> <span>你的余额</span> <span class="ml-15 mr-5">0</span>金币</li>
					<li class=""><span>下载所需</span><span class="ml-15 mr-5">{{price}}</span> 金币</li>
				</ul>
				<div class="info-choose flex">
					<img class="info-img" :src="LARGE_PATH" />
					<div class="ml-20 flex-box paymant flex flex-dir-col flex-c">
						<!-- 选择支付方式-单选 -->
						<RadioGroup on-change="" v-model="payType" class="flex" size="large">
								<Radio label="1" class="flex-c">
										<span class="iconfont iconicon-alipay"></span>
										<span :class="payType==1?'c-2d':''">支付宝</span>
								</Radio>
								<Radio label="2" class="flex-c mlr-40">
										<span class="iconfont iconweixincopy"></span>
										<span :class="payType==2?'c-2d':''">微信</span>
								</Radio>
								<!-- <Radio label="4" class="flex-c">
										<span class="iconfont iconjifen"></span>
										<span :class="payType==4?'c-2d':''">金币</span>
								</Radio> -->
						</RadioGroup>
						<div class="paymant-btn t-c f-16 bold c-ff mt-25 shou" @click="suresubmitPay">
							确认支付
						</div>
					</div>
				</div>
			</div>
			
			<!-- 跳转按钮 -->
			<div class="ptb-20 flex flex-x-e paymant-nav c-11 f-14 t-c">
				<div class="shou" @click="returnIndex('index')">返回首页</div>
				<div class="ml-30 shou"  @click="returnIndex">返回上一页</div>
			</div>
			
		</div>
		
		<div v-if="ispay" v-html="pagepay"></div>
		
	  <Modal
			 title="微信支付"
		   v-model="showWxcode"
			 onCancel="clickPaymodal"
			 onOk="clickPaymodal"
			 class-name="vertical-center-modal">
		 	 <div  id="qrcode" class=" flex-c"></div>
	  </Modal>
		
		<footer-view></footer-view>
		
		<!-- <form action="" id="payForm"></form> -->
		
	</div>
</template>

<script>
import headerList from './header_nav.vue'
import footerView from './footer.vue'
import QRCode from 'qrcodejs2'  // 引入qrcode
export default {
	components: {
		headerList,
		footerView
	},
	
  data () {
    return {
			payType: '1',
			thirdIden: '',
			LARGE_PATH: '',
			doclibName: '',
			SYS_TOPIC: '',
			ispay: false,
			pagepay: '',
			showWxcode: false,
			price:'',
			paying: false,
			state_time:null
		}
  },

  created () {
		let _this = this
		_this.thirdIden = _this.$route.query.thirdIden
		_this.LARGE_PATH = _this.$route.query.LARGE_PATH
		_this.doclibName = _this.$route.query.doclibName
		_this.SYS_TOPIC = _this.$route.query.SYS_TOPIC
		_this.price = _this.$route.query.price
	},
	
	mounted () {
		// this.bindpaymethod()
		// var dom1=document.querySelector('#payForm');
		// console.log(dom1)
		
	},

  methods: {
		// 获取支付方式
		async bindpaymethod () {
			let _this = this
			const res = await _this.get('/cart/getPayMethod.do?siteId=110')
		},
		
		// 确认提交订单
		async suresubmitPay () {
			let _this = this
			let data = {
				thirdIden: _this.thirdIden,
				payType: _this.payType - 0,
				orderType: 0,
				memberId: localStorage.getItem('id'),
				memberName: localStorage.getItem('username'),
				quantity: 1,
				billType: 0,
				integration: 0
			}
			const res = await _this.post('/order/submitRHEBOrder.do?'+ _this.util.urlEncode(data))
			if (res.result == 1) {
				const data = await _this.post('/order/payRHEBOrder.do?orderCode=' + res.data.orderSn + '&payType=' + (_this.payType - 0))
				if (data.result == 1) {
					if (_this.payType==1) {
						_this.alipay(data)
					} else {
						_this.wxpay(data.data)
						_this.state_time = setInterval( () => {
							_this.wxPaystate(res.data.orderSn) // 刷新该订单微信支付状态
						}, 2000)
					}
				} else {
					_this.$Message.error(data.error)
				}
			} else {
				_this.$Message.error(res.error)
			}
		},
		
		// 阿里支付
		alipay (data) {
			let _this =  this
			_this.pagepay = data.data
			_this.ispay = true
			_this.$Spin.show()
			var times = setInterval(() => {
				if (document.forms['payForm']) {
					clearInterval(times)
					document.forms['payForm'].submit()
					_this.$router.go(-1)
					_this.$Spin.hide()
				} else {
					
				}
			},500)
		},
		
		// 微信支付
		wxpay (text) {
			let _this = this
			_this.showWxcode = true
			if (_this.paying) {
				return
			}
			let qrcode = new QRCode('qrcode', {
				width: 132,  
				height: 132,
				text, // 二维码地址
				colorDark : "#000",
				colorLight : "#fff",
			})
			_this.paying = true
		},
		
		// 获取微信支付状态
		async wxPaystate (orderSn) {
			let _this = this 
			const res = await _this.post('/order/payQuaryOrder.do?orderCode=' + orderSn + '&payType=' + (_this.payType - 0))
			if (res.result == 1) {
				_this.showWxcode = false
				_this.util.showMsg('success','支付成功!',3,false)
				clearInterval(_this.state_time)
				setTimeout( () => {
					_this.$router.go(-1)
				},3000)
			}
		},
		
		// 点击模态删除dom
		clickPaymodal () {
		},
		
		returnIndex (page) {
			let _this = this
			if (page == 'index') {
				_this.$router.replace({path: '/index'})
			} else {
				_this.$router.go(-1)
			}
		}
		
	}
}
</script>

<style lang="less" scoped>
.paymant-page {
	background-color: #f1f2f6;
}
.paymant-box {
	width: 1100px;
	margin: 0 auto;
	padding: 145px 0 100px;
}
.paymant-info {
	width: 1098px;
	border: 1px solid #d8d8d8;
	padding: 0 50px;
	background-color: #fff;
	.consume {
		padding: 50px 0;
		border-bottom: 1px dashed   #eee;
		.balance {margin-right: 140px;}
	}
	.info-choose {
		padding: 20px 0 70px;
		.info-img {max-width: 300px;max-height: 200px;vertical-align: middle;}
		.paymant {
			height: 200px;
			background-color: #f4f4f4;
			border: 1px solid #e7e7e7;
		}
		.paymant-btn {
			background-color: #b81e20;
			width: 145px;
			height: 46px;
			border-radius: 23px;
			line-height: 46px;
		}
	}
}
.paymant-nav >div {
	width: 120px;
	height: 44px;
	border: 1px solid #d8d8d8;
	border-radius: 4px;
	line-height: 42px;
	background-color: #fff;
}

.c-2d {color:#2d8cf0}
.iconicon-alipay { color: #1494db; }
.iconweixincopy { color: #00d403; }
.iconjifen { color: #FFC335 ;}
.iconicon-alipay, .iconweixincopy, .iconjifen { font-size: 18px; margin: 0 5px; margin-top: 2px; }
</style>
